module.exports = __webpack_public_path__ + "img/aj-2000bet-web.e47078e8.jpg";